/*
========================================
Null-Return IT Services & Consulting
========================================

Copyright (c) 2022 Null-Return IT Services & Consulting (https://www.nullreturn-it.com)

* Original page skeleton coded by Creative-Tim
* While the template offered had some amazing pre-build components, it did not include everything we needed
* We have built upon and expanded it with our own code and components to deliver a a great site to view our services!

=====================================
Material Kit 2 (initial base code)
=====================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Base components coded by www.creative-tim.com
*/

/**
  The pxToRem() function helps you to convert a px unit into a rem unit, 
 */

function pxToRem(number, baseNumber = 16) {
  return `${number / baseNumber}rem`;
}

export default pxToRem;
